import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      labelPhoneNumber: formatMessage(messages.labelPhoneNumber),
      labelEmail: formatMessage(messages.labelEmail),
      labelPatients: formatMessage(messages.labelPatients),
      labelFamilyMembers: formatMessage(messages.labelFamilyMembers),
    };
  }, [formatMessage]);
  return translations;
};
export default useTranslations;
